import { Component, OnInit, ViewChild, ElementRef,EventEmitter, Input } from '@angular/core';
import { WbService } from '../wb.service';
import { WsService } from '../../utils/network/ws.service';
import { TranslateService } from 'ng2-translate/ng2-translate';
import {environment} from '../../../environments/environment';
import {WhiteBoardComponent, } from "../white-board.component";
import {SessionManagerService} from "../services/session/session-manager.service";
import {RecordingManagerService} from "../services/recording/recording-manager.service";
import {LayoutManagerService} from "../services/layout/layout-manager.service";
import {LogService} from "../services/log/log.service";

import {PermissionsManagerService} from "../services/permissions/permissions-manager.service";
declare var $;
declare var LC;
declare var LZString;
declare var AllMaterialsTool;
@Component({
  selector: "dskl-wb-graphic",
  templateUrl: 'graphic-wb.component.html',
  inputs: ["board"], 
  outputs: ["change", "onCurrentState"]
})
export class GraphicWbComponent extends WhiteBoardComponent{
   clearStates(){
        this.lc.clear();
    }
  @ViewChild('whiteboard') el: ElementRef;
  lc:any;
  getCurrentState(): JSON{
    console.log(this.lc.getSnapshot())
    var snap = this.lc.getSnapshot();
   if (snap && snap.shapes &&snap.shapes.length>0){
     for (let s of snap.shapes){
       if (s && s.className=='Image'){
         s.data.imageObject=null;
       }
     }
   }
    return snap;
    
  }
  onCurrentPageState(state: JSON, pageId){
    console.log("Will set state to page "+pageId)
    if (pageId!=this.board.pageId)return;
    this.lc.loadSnapshot(state);
    this.updatePainting();
  }
  onReady(){
    
    this.wbService.registerOnFileCallback(this);
 
    this.translatePageName();
  }
  onBackToGroups(){
    console.log("Will go back to groups");
  }
  onResize(){
    var height= this.getResizeTopOffset();
    height+=this.getResizeBottomOffset();
    var h = window.innerHeight - height;
    $(".literally").css("height", h);
    $(".literally canvas").css("height", h);
    $(".literally canvas").attr("height", h);
    console.log("Graphic board will resize to ", h)    
    this.updatePainting();
  }
  private updatePainting(){
    this.changing = true;
    this.lc.pan(0, 0);
    var self = this;
      setTimeout(function(){
        self.changing = false;
      }, 100);
  }
constructor(protected log: LogService, protected wbService: WbService, private wsService: WsService, private translate: TranslateService, protected sessionManager: SessionManagerService, protected recordingMediaManager: RecordingManagerService, protected layoutManagerService: LayoutManagerService,protected permissionsManager: PermissionsManagerService){
  super(log, wbService, sessionManager, layoutManagerService, permissionsManager);
}
  onViewReady() {
   // this.log.log("GraphicWbComponent", "On view ready, will init lc");
    console.log("after view init")
    //$(this.el.nativeElement).children().remove();
    var self = this;
    LC.init(this.el.nativeElement, {
      toolbarPosition: "top",
      imageSize: { width: null, height: 1460 },
      tools: [LC.tools.Pencil, LC.tools.Eraser, LC.tools.Line,
        LC.tools.Rectangle, LC.tools.Ellipse, LC.tools.Text, LC.tools.Pan/*,  AllMaterialsTool,MathTool, PdfTool, TasksTool, ShareTool, AllMaterialsTool*/],

      imageURLPrefix: 'assets/lc/img',

      onInit: function (o) {
        self.lc = o;
        self.onResize();
        o.on("clear", function (e) {
          self.changed("clear");
        });
        o.on("undo", function (e) {
        self.changed("undo");
        });
        o.on("redo", function (e) {
        self.changed("redo");
        });
        o.on("pan", function (e) {
          self.changed("pan", { x: e.x, y: e.y });
        })
        o.on("zoom", function (e) {
          self.changed("zoom", e.newScale);
        })
        o.on("shapeSave", function (e) {
          var value = LC.shapeToJSON(e.shape);
          if (value && value.className && value.className=="Image"){
            console.log("Preparing for serializaton", value)
            value.data.imageObject = null;
          }
          self.changed("shapeSave", value);

        });
      }

    });
    
  }
  translatePageName() {
    this.translate.get('WB_PAGE_NAME.PAGE_GRAPHIC').subscribe((res: string) => { this.pageName = res; });
    setTimeout(function(){
    if(environment.lng == 'de'){
        $(".color-well:first-child>label").text("Farbe");
        $(".color-well:last-child>label").text("Аusfüllen");
        $("div[title~=Pencil]").attr("title", "Stift");
        $("div[title~=Eraser]").attr("title", "Radierer");
        $("div[title~=Line]").attr("title", "Linie");
        $("div[title~=Rectangle]").attr("title", "Rechteck");
        $("div[title~=Ellipse]").attr("title", "Oval");
        $("div[title~=Text]").attr("title", "Text");
        $("div[title~=Pan]").attr("title", "Verschieben");
        $("div[title~=Undo]").attr("title", "Rückgängig");
        $("div[title~=Redo]").attr("title", "Wiederholen");
        $(".lc-zoom-out").attr("title", "Verkleinern");
        $(".lc-zoom-in").attr("title", "Vergrößern");
        $(".lc-clear").text('Neu');
    }
    }, 200);
  }
  pageName=" Графична дъска"
  getWbType(){
    return this.pageName;
  }
  changing:boolean = false;
  currentFile;
  showFile(f){

      var image = new Image();
		  image.src = environment.contentsBackendUrl + environment.contentsFileMapping + f.nameUuid+"/" +f.page + ".png";
      this.lc.saveShape(LC.createShape('Image', {x: 0, y: 0, image: image}))
    //  this.log.log("GraphicWbComponent", "Showing file "+image.src);
  }
  onState(state, pageId){

    if (pageId!=this.board.pageId){
      console.log("Not for me "+this.board.pageId+" but for "+pageId);
      console.log(state);
      return;
    }
   
    var w = state;
    //if (w && w.length>0 && w[0]=='{'){
     // w = JSON.parse(w);
      console.log("Type is ", w.type);
      
      this.changing = true;
      switch (w.type){
        case "shapeSave":
			w = LC.JSONToShape(w.value);
      
      this.lc.saveShape(w);
      break;
      case "clear": this.lc.clear(); break;
      case "undo": this.lc.undo(); break;
      case "redo": this.lc.redo(); break;
     
      //case "pan": this.lc.pan(); break;
		}
    var self = this;
      setTimeout(function(){
        self.changing = false;
      }, 100);
     //  this.log.log("GraphicWbComponent", "Got state "+w.type+" l: "+w.value.length);
    /*
    o = o.state;
			var w = o.content;
			console.log("Content is ", w);
			if (w){
				WbGraphic.addState(w);
			}else{
				//TODO set controls
				if (o.control){
					var d = JSON.parse(o.control)
					switch (d.type){
						case "undo": WbGraphic.undo(); break;
						case "redo": WbGraphic.redo(); break;
						case "clear": WbGraphic.clear(); break;
					}
				}
			}*/
 // }
  }


  private changed(type, value=null){
      if (this.changing) {
        console.log("Currently we are updating so no update")
        return;
      }
      console.log("changing")

      if (value && value.className && value.className=="Image"){
        value.data.imageObject = null;
      }
      
      this.emitChanged({ type: type, value: value });
    //  this.log.log("GraphicWbComponent", type+" l: "+value && value!=null?value.length:"");
}

}



// WEBPACK FOOTER //
// /app/src/app/wb/graphic/graphic-wb.component.ts